import React, { useContext } from "react";
import {
  Box,
  Pagination,
  FormControl,
  Select,
  MenuItem,
  PaginationItem,
} from "@mui/material";
import { styled } from "@mui/system";
import Act from "../../../../../../../../../../../store/actions";
import { StoreContext } from "../../../../../../../../../../../store/StoreProvider";

const CustomPagination = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { curTablePage, totalPage } = sna.AI;

  const handlePaginationChange = (e, value) => {
    dispatch({
      type: Act.SNA_SET_AI_TABLE_CURRENT_PAGE,
      payload: value,
    });
  };

  const handleSelectChange = (e) => {
    dispatch({
      type: Act.SNA_SET_AI_TABLE_CURRENT_PAGE,
      payload: e.target.value,
    });
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 190,
      },
    },
  };

  const StyledPaginationItem = styled(PaginationItem)({
    fontSize: "14px",
    padding: "8px",
    "&.Mui-selected": {
      borderColor: "#3BBFF0",
      backgroundColor: "#3BBFF01A !important",
    },
  });

  const StyledMenuItem = styled(MenuItem)({
    padding: "8px 8px 8px 16px",
  });

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Pagination
        count={totalPage}
        page={curTablePage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        onChange={handlePaginationChange}
        size="large"
        renderItem={(item) => <StyledPaginationItem {...item} />}
      />
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <span style={{ fontSize: "14px" }}>目前位於</span>
        <FormControl sx={{ width: "80px", margin: "0 8px" }} size="small">
          <Select
            value={curTablePage}
            onChange={handleSelectChange}
            MenuProps={MenuProps}
          >
            {Array.from({ length: totalPage }, (_, i) => (
              <StyledMenuItem key={i} value={i + 1}>
                {i + 1}
              </StyledMenuItem>
            ))}
          </Select>
        </FormControl>
        <span style={{ fontSize: "14px" }}>頁</span>
      </Box>
    </Box>
  );
};

export default CustomPagination;
